import { translationConstants } from "./translation.constants";

export const sportConstants = {
  SAILING: 1,
  KITESURFING: 2,
  WINGFOILING: 3,
  WINDSURFING: 4,
};

export const sportConstantsReversed = {
  1: "SAILING",
  2: "KITESURFING",
  3: "WINGFOILING",
  4: "WINDSURFING",
};

export const boatTypeEnum = {
  DINGHY: 1,
  KEELBOAT: 2,
  MULTI_HULL: 3,
  YACHT: 4,
  FORMULA_KITE: 5,
  KITE_BOARDER: 6,
  IQFOIL: 7,
  WIND_SURFER: 8,
  FORMULA_WING: 9,
  WING_FOILER: 10,
};

export const boatTypeEnumReversed = {
  1: "DINGHY",
  2: "KEELBOAT",
  3: "MULTI_HULL",
  4: "YACHT",
  5: "FORMULA_KITE",
  6: "KITE_BOARDER",
  7: "IQFOIL",
  8: "WIND_SURFER",
  9: "FORMULA_WING",
  10: "WING_FOILER",
};

export const levelEnum = {
  GENERAL_TRAINING: 0,
  AMATEUR: 1,
  RACER: 2,
  ELITE: 3,
};

export const levelEnumReversed = {
  0: "GENERAL_TRAINING",
  1: "AMATEUR",
  2: "RACER",
  3: "ELITE",
};

export const proficiencyLevelEnum = {
  BEGINNER: 1,
  INTERMEDIATE: 2,
  ADVANCED: 3,
};

export const proficiencyLevelEnumReversed = {
  1: "BEGINNER",
  2: "INTERMEDIATE",
  3: "ADVANCED",
};
